import { TranslationService } from './services/translation/translation.service';
import { Component, HostListener, Inject, OnInit, Renderer2 } from '@angular/core';
import { LocalStorageService } from './services/shared/local-storage/local-storage.service';
import { UtilsService } from './services/shared/utils/utils.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { AppStateService } from './services/shared/app-state/app-state.service';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  constructor(
    private translationService: TranslationService,
    private lStorage: LocalStorageService,
    private utils: UtilsService,
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private appState: AppStateService,
    @Inject(DOCUMENT) private document: Document
  ) { }
  title = 'customerdiscoverycenter.client';
  isEmbed: boolean = false;
  isDesktop: boolean = true;
  private resolutionLinkElement: HTMLLinkElement | null = null;
  private embedLinkElement: HTMLLinkElement | null = null;

  ngOnInit(): void {

    //Load translations
    this.translationService.loadTranslations('fr');

    //Clean Local Storage
    this.lStorage.cleanExpiredItems();

    //Adjust page size
    setTimeout(() => {
      this.adjustZoom();
    }, 0);

    //Update Title page
    this.updateTitleOnRouteChange();

    //Set global variables
    this.route.queryParams.subscribe(params => {

      this.isEmbed = params['embed']?.toLowerCase() === 'true';
      this.appState.setIsEmbed(this.isEmbed);
      if (this.isEmbed) {
        this.renderer.addClass(this.document.body, 'isEmbed');
      } else {
        this.renderer.removeClass(this.document.body, 'isEmbed');
      }

      this.isDesktop = this.utils.isDesktop();
      this.updateTheme();

      const isPreview = this.router.url.includes('/preview');
      this.appState.setIsPreview(isPreview);
    });


  }
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.adjustZoom();
    this.route.queryParams.subscribe(params => {

      this.isEmbed = params['embed']?.toLowerCase() === 'true';
      this.appState.setIsEmbed(this.isEmbed);
      if (this.isEmbed) {
        this.renderer.addClass(this.document.body, 'isEmbed');
      } else {
        this.renderer.removeClass(this.document.body, 'isEmbed');
      }

      this.isDesktop = this.utils.isDesktop();
      this.updateTheme();
    });
  }

  adjustZoom() {
    // Get references to the root application element and the sidenav container
    var app_root = document.querySelector('app-root') as HTMLElement;

    // Get the device's pixel ratio
    var zoom = window.devicePixelRatio;

    if (app_root) {
      // Define the base width and height for scaling
      var baseWidth = 1920; // Base width of the wrapper
      var baseHeight = 1080; // Base height of the wrapper

      // Calculate the scale ratios based on the window size
      //var scaleWidth = (window.outerWidth * zoom);
      //var scaleHeight = (window.outerHeight * zoom);

      var scaleWidth = (window.screen.width * zoom);
      var scaleHeight = (window.screen.height * zoom);

      if (scaleWidth >= 1024 && scaleHeight >= 768 && scaleWidth < 1920 && scaleHeight < 1080 && this.utils.isDesktop()) {
        // Use the smallest scale value to maintain the aspect ratio
        var scale = Math.min(scaleWidth / baseWidth, scaleHeight / baseHeight);

        // Dynamically set the zoom level of the wrapper
        app_root.style.setProperty('zoom', scale.toString());

      } else {
        // Dynamically set the zoom level of the wrapper
        app_root.style.setProperty('zoom', '1');
      }
    }
  }

  updateTitleOnRouteChange() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.router.routerState.root;
          while (child.firstChild) {
            child = child.firstChild;
          }
          return child.snapshot.data['title'];
        })
      )
      .subscribe((title: string) => {
        if (title) {
          var fullTitle = !title.startsWith('SOLOCAL') ? 'CDC - ' + this.translationService.translate(title) : this.translationService.translate(title);
          this.titleService.setTitle(fullTitle);
        }
      });
  }

  private updateTheme(): void {
    const resolutionCss = (this.isEmbed || !this.isDesktop)
      ? 'assets/css/mobile.css'
      : 'assets/css/desktop.css';

    if (this.resolutionLinkElement?.getAttribute('href') !== resolutionCss) {
      this.resolutionLinkElement = this.applyStylesheet(resolutionCss, this.resolutionLinkElement, true);
    }

    if (this.isEmbed) {
      if (!this.embedLinkElement) {
        this.embedLinkElement = this.applyStylesheet('assets/css/embed.css', null, false);
      }
    } else {
      if (this.embedLinkElement) {
        this.renderer.removeChild(this.document.head, this.embedLinkElement);
        this.embedLinkElement = null;
      }
    }
  }

  private applyStylesheet(href: string, oldElement: HTMLLinkElement | null, insertBefore: boolean): HTMLLinkElement {
    if (oldElement) {
      this.renderer.removeChild(this.document.head, oldElement);
    }

    const newLink = this.renderer.createElement('link');
    this.renderer.setAttribute(newLink, 'rel', 'stylesheet');
    this.renderer.setAttribute(newLink, 'href', href);

    if (insertBefore) {
      this.renderer.insertBefore(
        this.document.head,
        newLink,
        this.document.head.firstChild
      );
    } else {
      this.renderer.appendChild(this.document.head, newLink);
    }

    return newLink;
  }
}
